import React, { FC, useMemo } from 'react';
import { IntlShape } from 'react-intl';
import { useT } from '@transifex/react';
import { BankAffiliateBanner } from 'components/Banks/BankDetails/BankAffiliateProduct/BankAffiliateBanner/v1';
import CountryFlag from 'components/Banks/CountryFlag';
import { DBSProduct } from 'types';
import { BankDetailsType } from 'types/bank';
import {
  formatTermForBannerHero,
  getAffiliateBankProductUSPListItems,
} from 'utils/bankPageUtils/bankOffers';
import productPageMessages from '../../../messages';

interface ProductPageHeroBannerProps {
  bank: BankDetailsType;
  offers: DBSProduct[];
  selectedOffer: DBSProduct;
  intl: IntlShape;
}

const ProductPageHeroBanner: FC<ProductPageHeroBannerProps> = ({
  bank,
  offers,
  selectedOffer,
  intl,
}) => {
  const t = useT();
  const bannerProps = useMemo(
    () => ({
      title: formatTermForBannerHero(selectedOffer, bank, intl, t),
      subtitle: (
        <>
          <span>{t(productPageMessages.affiliateHeroBannerCountryOriginSubtitle)}:</span>
          <CountryFlag
            countryId={bank.statutory_deposit_guarantee_scheme.country.id}
            altText={bank.statutory_deposit_guarantee_scheme.country.name}
          />
          {bank.statutory_deposit_guarantee_scheme.country.name}
        </>
      ),
      listItems: getAffiliateBankProductUSPListItems(bank, offers, selectedOffer, intl, t),
      imageSrc: bank?.logo_url || bank?.bank_logo_url,
    }),
    [bank, selectedOffer, offers, t],
  );

  return <BankAffiliateBanner {...bannerProps} />;
};

export default ProductPageHeroBanner;
